// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   EMPTY STATE CARD STYLES
   ============================================ */

.empty-state-card {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 2rem;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3);
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.01);
  border-bottom: 1px solid rgba(255, 255, 255, 0.01);
}

.empty-state-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.75rem;
}

.empty-state-icon {
  color: rgba(255, 255, 255, 0.4);
  margin-bottom: 0.5rem;
}

.empty-state-icon svg {
  width: 48px;
  height: 48px;
}

.empty-state-title {
  font-size: 1.25rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

.empty-state-subtitle {
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
  max-width: 280px;
  line-height: 1.5;
}

.empty-state-actions {
  margin-top: 1rem;
  display: flex;
  gap: 0.75rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .empty-state-card {
    min-height: 150px;
    padding: 1.5rem;
  }
  
  .empty-state-icon svg {
    width: 36px;
    height: 36px;
  }
  
  .empty-state-title {
    font-size: 1.1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/empty-state.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB;sCACoC;EACpC,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* ============================================\n   EMPTY STATE CARD STYLES\n   ============================================ */\n\n.empty-state-card {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  padding: 2rem;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 20px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3);\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  border-top: 1px solid rgba(255, 255, 255, 0.01);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.01);\n}\n\n.empty-state-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 0.75rem;\n}\n\n.empty-state-icon {\n  color: rgba(255, 255, 255, 0.4);\n  margin-bottom: 0.5rem;\n}\n\n.empty-state-icon svg {\n  width: 48px;\n  height: 48px;\n}\n\n.empty-state-title {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.9);\n  margin: 0;\n}\n\n.empty-state-subtitle {\n  font-size: 0.875rem;\n  color: rgba(255, 255, 255, 0.5);\n  margin: 0;\n  max-width: 280px;\n  line-height: 1.5;\n}\n\n.empty-state-actions {\n  margin-top: 1rem;\n  display: flex;\n  gap: 0.75rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .empty-state-card {\n    min-height: 150px;\n    padding: 1.5rem;\n  }\n  \n  .empty-state-icon svg {\n    width: 36px;\n    height: 36px;\n  }\n  \n  .empty-state-title {\n    font-size: 1.1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
